var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pageBom"},[_c('div',{staticClass:"footerBom"},[_vm._v(" ©2021 浙江国通电气科技有限公司 版权所有 浙ICP备20006768号-1 ")])])}]

export { render, staticRenderFns }